import React, { useMemo } from "react";

import SampleFunctionContext from "../../../../SampleSubmission/SampleFunctionContext";
import SampleSubmissionContext from "../../../../SampleSubmission/SampleSubmissionContext";
import SubmissionReceiptModal from "../../../../SampleSubmission/SampleSubmissionModal/SubmissionReceiptModal/SubmissionReceiptModal";

export default function NewSampleRetestReceiptModal({
  showReceipt,
  onClose,
  submission,
  sampleCategory = "product",
}) {
  const sampleFunctionValue = useMemo(() => ({
    setOnAddBackButton: () => {},
  }), []);

  const sampleSubmissionValue = useMemo(() => ({
    isLoggedOut: false,
    sampleCategory,
    thirdParty: false,
  }), [sampleCategory]);

  return (
    <SampleSubmissionContext.Provider value={sampleSubmissionValue}>
      <SampleFunctionContext.Provider value={sampleFunctionValue}>
        <SubmissionReceiptModal
          showReceipt={showReceipt}
          handleReceipt={onClose}
          submissionFromParent={submission}
          maskClosable={false}
        />
      </SampleFunctionContext.Provider>
    </SampleSubmissionContext.Provider>
  );
}
